(function () {
  const tableTrigger = document.getElementsByClassName('trade-order__header--show-details');

  for (let ind = 0; ind < tableTrigger.length; ind++) {
    const trigger = tableTrigger[ind];
    const showLabel = trigger.getAttribute('data-show-label');
    const hideLabel = trigger.getAttribute('data-hide-label');

    trigger.addEventListener('click', (e) => {
      const tableHeader = trigger.parentElement;
      const nextSibling = tableHeader.nextElementSibling;
      const orderDetails = nextSibling.getElementsByClassName('trade-order-table__details');
      const isShowing = orderDetails[0].classList.contains('show') ? true : false;
      const label = trigger.getElementsByClassName('inner-label');

      if (!isShowing) {
        orderDetails[0].classList.add('show');
        label[0].innerHTML = hideLabel;
      } else {
        orderDetails[0].classList.remove('show');
        label[0].innerHTML = showLabel;
      }

      return false;
    });
  }
})();
